<template>
    <v-select
        v-if              = "items"
        :items            = "items"
        item-value        = "id"
        item-text         = "name"
        :label            = "label"
        v-model           = "seletced"
        :return-object    = true
        :rules            = "rules"
        @change           = "onChange"
        :readonly         = "readonly"
        :hide-details     = "hideDetails"
        :multiple         = "multiple"
        :clearable        = "clearable"
        :background-color = background
    >
        <template v-slot:selection="{ item }">
            <div class="item-selection v-list-item__title">
                {{ item.name }}
            </div>
        </template>
    </v-select>
</template>

<script>

export default {
    name : "FEnumSelect",
    props: {
        value: {
            required: true
        },
        label: {
            required: true,
        },
        module: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        rules: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        readonly: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        hideDetails: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            },
        },
        multiple: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            },
        },
        clearable: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            },
        },
        background: {
            required: false,
            type    : String,
            default : function () {
                return null
            }
        },
        exclude: {
            required: false,
            type    : Array,
            default : function () {
                return []
            }
        }
    },

    data: () => ({
        seletced: null,
    }),

    mounted() {
        this.seletced = this.value;
    },

    watch: {
        value () {
            this.seletced = this.value;
        }
    },

    computed: {
        items () {
            const enums = this.$store.getters [this.module];
            if (this.exclude && this.exclude.length > 0) {
                return enums[this.type].filter(v => !this.exclude.includes(v.id));
            }

            return enums[this.type]
        }
    },

    methods: {
        onChange () {
            this.$emit('input', this.seletced);
        }
    }
}
</script>

<style scoped>

.item-selection {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis; width: calc(100% - 1px);
}

</style>